module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/agency-c69e45a8e9ba11d4b1e712ca6efac5fc.jpg";